var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconOption(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 23.468,
    height: 23.468,
    viewBox: "0 0 23.468 23.468",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "\\uC0AC\\uAC01\\uD615_17",
    "data-name": "\\uC0AC\\uAC01\\uD615 17",
    width: 23.468,
    height: 23.468,
    fill: "#8c8c8c"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_7",
    "data-name": "\\uADF8\\uB8F9 7",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_3",
    "data-name": "\\uD328\\uC2A4 3",
    d: "M8.512,24.2a2.227,2.227,0,0,1-1.579-.652L.654,17.267a2.233,2.233,0,0,1,0-3.159L11.943,2.818a2.226,2.226,0,0,1,1.812-.642l4.239.444a.5.5,0,0,1-.1.986l-4.239-.444a1.238,1.238,0,0,0-1.008.357L1.355,14.81a1.242,1.242,0,0,0,0,1.757l6.278,6.28a1.245,1.245,0,0,0,1.757,0L20.679,11.555a1.236,1.236,0,0,0,.357-1.008l-.742-7.084a.5.5,0,1,1,.986-.1l.742,7.085a2.224,2.224,0,0,1-.643,1.812L10.091,23.547A2.228,2.228,0,0,1,8.512,24.2Z",
    transform: "translate(0 -0.733)",
    fill: "#8c8c8c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uC120_3",
    "data-name": "\\uC120 3",
    d: "M-.254,4.391A.494.494,0,0,1-.6,4.246a.5.5,0,0,1,0-.7L3.545-.6a.5.5,0,0,1,.7,0,.5.5,0,0,1,0,.7L.1,4.246A.494.494,0,0,1-.254,4.391Z",
    transform: "translate(9.614 12.078)",
    fill: "#8c8c8c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uC120_4",
    "data-name": "\\uC120 4",
    d: "M-.254,6.26A.494.494,0,0,1-.6,6.115a.5.5,0,0,1,0-.7L5.414-.6a.5.5,0,0,1,.7,0,.5.5,0,0,1,0,.7L.1,6.115A.494.494,0,0,1-.254,6.26Z",
    transform: "translate(6.018 10.351)",
    fill: "#8c8c8c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_4",
    "data-name": "\\uD328\\uC2A4 4",
    d: "M23.337,9.213a2.25,2.25,0,0,1-.522-4.437.5.5,0,1,1,.23.965,1.258,1.258,0,1,0,1.549,1.225,1.162,1.162,0,0,0-.274-.781.5.5,0,0,1,.03-.672L29.771.144a.5.5,0,0,1,.7.7l-5.13,5.081a2.187,2.187,0,0,1,.247,1.035A2.251,2.251,0,0,1,23.337,9.213Z",
    transform: "translate(-7.148 0)",
    fill: "#8c8c8c"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconOption);
export default __webpack_public_path__ + "static/media/icon_option.e1dcb638da6f17649d00ab31fd4b2372.svg";
export { ForwardRef as ReactComponent };